import React from 'react'

const ClockWarning16pxSvg = (props) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.00016 1.33325C4.32683 1.33325 1.3335 4.32658 1.3335 7.99992C1.3335 11.6733 4.32683 14.6666 8.00016 14.6666C11.6735 14.6666 14.6668 11.6733 14.6668 7.99992C14.6668 4.32658 11.6735 1.33325 8.00016 1.33325ZM10.9002 10.3799C10.8068 10.5399 10.6402 10.6266 10.4668 10.6266C10.3802 10.6266 10.2935 10.6066 10.2135 10.5533L8.14683 9.31992C7.6335 9.01325 7.2535 8.33992 7.2535 7.74658V5.01325C7.2535 4.73992 7.48016 4.51325 7.7535 4.51325C8.02683 4.51325 8.2535 4.73992 8.2535 5.01325V7.74658C8.2535 7.98658 8.4535 8.33992 8.66016 8.45992L10.7268 9.69325C10.9668 9.83325 11.0468 10.1399 10.9002 10.3799Z" fill="#F97C00" />
        </svg>
    )
}

export default ClockWarning16pxSvg